<template>
  <div v-if="totalObjects > 0">
    <v-organisation-banner
      :organisation="organisation"
      :commercials-count="totalObjects"
      :reviews-count="organisationStatistics.reviews_count"
    />
    <div class="row">
      <div class="col-md-6">
        <v-commercial-researches-block
          icon="play-circle"
          title="phrase.most_recent_commercial"
          :researches="objectList.slice(0, 1)"
          v-if="totalObjects > 0"
          :columns="1"
        />

        <v-commercial-researches-block
          icon="play-circle"
          title="phrase.previous_commercials"
          :researches="objectList.slice(1)"
          v-if="totalObjects > 1"
          :columns="2"
        />
      </div>
      <div class="col-md-6">
        <v-organisation-info-block
          :organisation="organisation"
          :commercials-count="totalObjects"
          :reviews-count="organisationStatistics.reviews_count"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CommercialResearchesBlock from '@/reviewer/components/CommercialResearchesBlock.vue';
import OrganisationBanner from '@/reviewer/components/OrganisationBanner.vue';
import OrganisationInfoBlock from '@/organisation/components/OrganisationInfoBlock.vue';
import { fetchOrganisationStatistics } from '@/public/api';
import { GenericListMixin } from '@/common/utils/mixins';

export default {
  name: 'OrganisationViewDefault',
  components: {
    'v-commercial-researches-block': CommercialResearchesBlock,
    'v-organisation-banner': OrganisationBanner,
    'v-organisation-info-block': OrganisationInfoBlock,
  },
  props: {
    organisation: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    researches: [],
    organisationStatistics: null,
    apiPath: 'rev/researches/',
  }),
  mixins: [GenericListMixin],
  methods: {
    getParams() {
      return {
        organisation: this.organisation.slug,
        page_size: 51,
      };
    },
    async fetchOrganisationStatistics() {
      const response = await fetchOrganisationStatistics(this.organisation.slug);
      if (response.status === 200) {
        this.organisationStatistics = response.data;
      }
    },
  },
  created() {
    this.fetchOrganisationStatistics();
  },
};
</script>
